<div class="acquisition-dashboard">
  <h3>Dashboard aquisição</h3>
  <div class="filters">
    <form class="form-b4a" [formGroup]="form">
      <span class="p-float-label">
        <p-dropdown
          inputId="subscriptionId"
          [options]="subscriptions"
          (onChange)="changeSubscription()"
          formControlName="subscriptionId"
          appendTo="body"
          [autoDisplayFirst]="false"
        >
        </p-dropdown>
        <label for="subscriptionId">Assinatura</label>
      </span>
      <span class="p-float-label">
        <p-dropdown
          inputId="editionId"
          [options]="editions"
          *ngIf="editions"
          optionValue="editionId"
          optionLabel="theme"
          (onChange)="changeEdition()"
          [filter]="true"
          filterBy="theme,title,editionId,description"
          filterMatchMode="contains"
          [autoDisplayFirst]="false"
          formControlName="editionId"
          appendTo="body"
        >
          <ng-template pTemplate="item" let-edition>
            <ng-container *ngIf="form.value.subscriptionId">
              {{ edition.theme }}
              {{ editionDate(edition.editionId) }}
            </ng-container>
            <ng-container *ngIf="!form.value.subscriptionId">
              {{ editionDateName(edition.editionId) | titlecase }}
            </ng-container>
          </ng-template>
          <ng-template pTemplate="selectedItem">
            <ng-container *ngIf="form.value.subscriptionId">
              {{ edition?.theme }}
            </ng-container>
            <ng-container
              *ngIf="edition && edition.editionId && !form.value.subscriptionId"
            >
              {{ editionDateName(edition.editionId) | titlecase }}
            </ng-container>
          </ng-template>
        </p-dropdown>
        <label for="editionId">Edição</label>
      </span>
    </form>
    <div class="picture">
      <app-edition-image
        [imageURL]="edition.imageURL"
        [editionId]="edition.editionId"
        *ngIf="edition"
      ></app-edition-image>
    </div>
  </div>
  <div class="dashboard" *ngIf="ready">
    <div class="left-info">
      <app-coupons-usage-summary-report
        [coupons]="couponUsages"
        [couponUsageTypes]="couponUsageTypes"
        [editionId]="form.value.editionId"
        *ngIf="couponUsages && couponUsageTypes"
      ></app-coupons-usage-summary-report>
    </div>
    <div class="right-info charts">
      <p-chart
        type="bar"
        [data]="chartData"
        [options]="chartConfig"
        id="chart"
        [responsive]="false"
        [width]="width"
        height="500px"
        #chart
        *ngIf="chartData && width"
      />
    </div>
  </div>
</div>
